import { SlideButtonProps } from '../../../types';
import { CurrentSlideIcon } from '../../atoms/CurrentSlideIcon';
import { PresentationNavigationButton } from '../../atoms/PresentationNavigationButton';
import { useTranslation } from 'react-i18next';

export const CurrentSlideButton = (props: SlideButtonProps) => {
    const { t } = useTranslation();
    const { onClick, classNames } = props;
    return (
        <PresentationNavigationButton type="button" onClick={onClick} className={`${classNames}`} testId="LastButton">
            <span className="sr-only">{t('Slide.Button.Current')}</span>
            <CurrentSlideIcon />
        </PresentationNavigationButton>
    );
};
